// eslint-disable-next-line prefer-const
let Postlogin = (function (my) {
    my.initialized = false;
    my.init = function () {
        if (my.initialized) {
            return;
        }
        my.initialized = true;

        // Off-canvas drawer toggle for tablet/mobile
        $('.sidebar-toggle').on('click', function () {
            const $leftMenu = $('.left-menu');
            const $overlay = $('.drawer-overlay');
            const $icon = $(this).find('i');

            $leftMenu.toggleClass('drawer-open');
            $overlay.toggleClass('show');
            $('body').toggleClass('drawer-open');

            const isOpen = $leftMenu.hasClass('drawer-open');
            $(this).attr('aria-expanded', isOpen);
            if (isOpen) {
                $icon.removeClass('fa-bars').addClass('fa-xmark');
            } else {
                $icon.removeClass('fa-xmark').addClass('fa-bars');
            }
        });

        // Close drawer when clicking overlay
        $('.drawer-overlay').on('click', function () {
            $('.left-menu').removeClass('drawer-open');
            $(this).removeClass('show');
            $('body').removeClass('drawer-open');
            $('.sidebar-toggle').attr('aria-expanded', 'false');
            $('.sidebar-toggle i').removeClass('fa-xmark').addClass('fa-bars');
        });

        $('.reset-lesson-progress').on('click', function (e) {
            e.preventDefault();
            const url = this.href;
            // do the AJAX request to your server-side script
            $.ajax({
                url,
                type: 'get',
                success() {
                    window.location.reload();
                },
                error() {
                    //
                },
            });

            return false;
        });

        $('.kill-session-link').on('click', function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            $.get(url, () => {
                window.location.reload(true);
            });

            return false;
        });

        if ($('.bar').length) {
            $('.bar').each(function () {
                const $bar = $(this);
                setTimeout(() => {
                    $bar.css('width', `${$bar.attr('data-percent')}%`);
                }, 500);
            });
        }

        // show confirm dialog when clicking on Delete button
        $(document).on('submit', '.delete-entry', () => window.confirm('Are you sure you want to delete this?'));

        // show confirm dialog when clicking on Clone button
        $(document).on('submit', '.clone-entry', () => window.confirm('Are you sure you want to clone this?'));

        // set up multi-lang fields
        if ($('.multilang-field').length) {
            $('.multilang-field').each(function () {
                const $container = $(this);
                $(this)
                    .find('.field-container')
                    .append(
                        '<div class="flags"><div class="wrapper"><div class="flag flag-en" lang="en">English</div><div class="flag flag-es" lang="es">Spanish</div></div></div>',
                    );
                $(this).on('click', '.flag', function () {
                    $container.attr('lang', $(this).attr('lang'));
                });
            });
        }

        if ($('input[type=file].file-upload').length) {
            $('input[type=file].file-upload').each(function () {
                const defaultFilePath = $(this).attr('value');
                if (defaultFilePath !== '') {
                    $(this).fileinput({
                        showUpload: false,
                        allowedFileTypes: ['pdf'],
                        initialPreview: `<embed class="kv-preview-data" src="${defaultFilePath}" width="160px" height="160px" type="application/pdf">`,
                        previewFileType: 'pdf',
                        previewFileIcon: '<i class="fa fa-file"></i>',
                        initialPreviewFileType: 'pdf',
                        initialPreviewAsData: false,
                        initialPreviewConfig: [
                            {
                                caption: defaultFilePath,
                                showDelete: false,
                                showDrag: false,
                            },
                        ],
                    });
                } else {
                    $(this).fileinput({
                        showUpload: false,
                    });
                }

                $(this).on('fileclear', function () {
                    $(`input[name="${$(this).attr('name')}"]`).attr('value', '');
                });
            });
        }

        if ($('input[type=file].image-upload').length) {
            $('input[type=file].image-upload').each(function () {
                const defaultFilePath = $(this).attr('value');
                if (defaultFilePath !== '') {
                    $(this).fileinput({
                        showUpload: false,
                        allowedFileTypes: ['image'],
                        initialPreview: defaultFilePath,
                        initialPreviewAsData: true,
                        initialPreviewConfig: [
                            {
                                caption: defaultFilePath,
                                showDelete: false,
                                showDrag: false,
                            },
                        ],
                    });
                } else {
                    $(this).fileinput({
                        showUpload: false,
                    });
                }

                $(this).on('fileclear', function () {
                    $(`input[name="${$(this).attr('name')}"]`).attr('value', '');
                });
            });
        }

        if ($('input[type=file].audio-upload').length) {
            $('input[type=file].audio-upload').each(function () {
                const defaultFilePath = $(this).attr('value');
                if (defaultFilePath !== '') {
                    $(this).fileinput({
                        showUpload: false,
                        allowedFileTypes: ['audio'],
                        initialPreviewFileType: 'audio',
                        initialPreview:
                            '<audio controls>'
                            + `    <source src="${defaultFilePath}" type="audio/mpeg" title="${defaultFilePath}">`
                            + '    Your browser does not support the audio tag.'
                            + '</audio>',
                        initialPreviewAsData: false,
                        showZoom: false,
                        initialPreviewConfig: [
                            {
                                caption: defaultFilePath,
                                showDelete: false,
                                showDrag: false,
                            },
                        ],
                    });
                } else {
                    $(this).fileinput({
                        showUpload: false,
                    });
                }
                $(this).on('fileclear', function () {
                    $(`input[name="${$(this).attr('name')}"]`).attr('value', '');
                });
            });
        }

        // if the license filter field exists
        if ($('#license-filter').length) {
            // whenever the users makes a selection, save that in a cookie and refresh the page
            $('#license-filter').on('change', () => {
                const selectedLicense = $('#license-filter').val();
                Cookies.set('selected_license', JSON.stringify(selectedLicense));
                window.location.reload();
            });

            if ($('#license-filter option').length > 1) {
                const cookieLicense = Cookies.get('selected_license');
                if (typeof cookieLicense !== 'undefined' && cookieLicense !== '') {
                    const selectedLicense = JSON.parse(Cookies.get('selected_license'));
                    $(`#license-filter option[value="${selectedLicense}"]`).prop('selected', true);
                }
            } else {
                // otherwise, if there's only one option (maybe we're on an edit page), make that the new remembered cookie license
                const selectedLicense = $('#license-filter').val();
                Cookies.set('selected_license', JSON.stringify(selectedLicense));
            }
        }
    };

    return my;
}(Postlogin || {}));
